/**
 * @author Kvadrat
 * This file contains code copied from:
 * https://github.com/inter-ikea/cbf-re-ipex-kvadrat
 */

const fractionsReg = new RegExp(/^([1-9][0-9]*\/[1-9][0-9]*)["″"]?$/g);
const inchReg = new RegExp(/^(0|[1-9][0-9]*)["″"]?$/g);
const footReg = new RegExp(/^(\d{1,})[´'′]$/g);
const feetInchReg = new RegExp(/^([1-9][0-9]*)["″"'′´]?\s*([1-9][0-9]*)["″"'′´]?$/g);
const feetInchFractionReg = new RegExp(
  /^([0-9][0-9]*)["″"'′´]?\s*([0-9][0-9]*)["″"'′´]?\s*([0-9][0-9]*\/[0-9][0-9]*)["″"]?$/g
);
const numberFractionReg = new RegExp(
  /^([1-9][0-9]*)(["″"'′´]?)\s*([1-9][0-9]*\/[1-9][0-9]*)["″"]?$/
);
const anyLastSignReg = new RegExp(/[-!$%^&*()_¤+#|~={}[\]:";<>?,./"″"´'′]$/);
const feetSignReg = new RegExp(/['′´]/);

const FEET_TO_INCHES = 12;

function parseFractions(input: string): number | undefined {
  fractionsReg.lastIndex = 0;

  const result = fractionsReg.exec(input.trim());
  if (result) {
    return eval(result[1]);
  }
}

function parseInches(input: string): number | undefined {
  inchReg.lastIndex = 0;

  const result = inchReg.exec(input.trim());
  if (result) {
    return Number.parseInt(result[1]);
  }
}

function parseFeet(input: string): number | undefined {
  footReg.lastIndex = 0;

  const result = footReg.exec(input.trim());
  if (result) {
    return Number.parseInt(result[1]) * FEET_TO_INCHES;
  }
}

function parseFeetAndInches(input: string): number | undefined {
  feetInchReg.lastIndex = 0;

  const result = feetInchReg.exec(input.trim());
  if (result) {
    return Number.parseInt(result[1]) * FEET_TO_INCHES + Number.parseInt(result[2]);
  }
}

function parseFeetInchesAndFractions(input: string): number | undefined {
  feetInchFractionReg.lastIndex = 0;
  anyLastSignReg.lastIndex = 0;

  const result = feetInchFractionReg.exec(input.trim());
  if (result) {
    return (
      Number.parseInt(result[1]) * FEET_TO_INCHES +
      Number.parseInt(result[2]) +
      eval(result[3].replace(anyLastSignReg, ''))
    );
  }
}

function parseNumberAndFractions(input: string): number | undefined {
  numberFractionReg.lastIndex = 0;

  const result = numberFractionReg.exec(input.trim());
  if (result) {
    const [, value, sign, fraction] = result;
    const factor = feetSignReg.test(sign) ? FEET_TO_INCHES : 1;

    return parseInt(value) * factor + eval(fraction);
  }
}

const parseImperialOrder = [
  parseFractions,
  parseInches,
  parseFeet,
  parseNumberAndFractions,
  parseFeetAndInches,
  parseFeetInchesAndFractions
];

/**
 * Parse imperial string from input
 * @param value
 * @returns Feet, inches and fractions as numbers
 */
function parseImperial(value: string) {
  for (const functions of parseImperialOrder) {
    const result = functions(value);
    if (!isNaN(result!)) {
      return result;
    }
  }
}

function parseMetric(value: string): number {
  return Number(value.replace(',', '.').replace(/\s/g, ''));
}

export { parseImperial, parseMetric, parseNumberAndFractions };
